import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { HtmlAnchor } from '@atlassian/help-center-common-component/analytics/html-anchor';

// eslint-disable-next-line rulesdir/no-styled-export
export const Container = styled.div`
    ${mixins.borderBox};
    ${mixins.borderRadius};
    padding: ${token('space.200', '16px')} 0;
    color: ${token('color.text.danger', colors.R500)};
    margin-top: ${token('space.100', '8px')};
    &:focus {
        outline: none;
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Header = styled.div`
    display: flex;
    align-items: center;
    height: ${grid.multiple(4).px};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Content = styled.div`
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Icon = styled.div`
    margin-right: ${token('space.050', '4px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Title = styled.span`
    ${mixins.clamp};
    color: ${token('color.text.danger', colors.R500)};
    display: flex;
    align-items: center;
    flex: 1;
    font-weight: 600;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Link = styled(HtmlAnchor)`
    /* important used here to override links getting themed */
    color: ${token('color.text.danger', colors.R500)} !important;
    font-weight: 600;
    text-decoration: underline;
`;
